var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalingLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75,
    zoomAndPan: "magnify",
    viewBox: "0 0 56.25 56.249997",
    height: 75,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 531.504665 254.979526 L 522.41019 254.979526 L 522.41019 147.962414 L 531.504665 134.280788 Z M 531.504665 254.979526 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 531.504665 134.280788 L 522.41019 147.962414 L 523.425198 147.962414 L 523.425198 134.280788 Z M 531.504665 134.280788 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.875 10.914062 L 41.6875 10.941406 L 41.847656 12.234375 L 41.875 12.230469 Z M 41.875 10.914062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.6875 10.941406 L 41.503906 11.019531 L 41.824219 12.246094 L 41.847656 12.234375 Z M 41.6875 10.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.503906 11.019531 L 41.332031 11.148438 L 41.796875 12.265625 L 41.824219 12.246094 Z M 41.503906 11.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.332031 11.148438 L 41.183594 11.320312 L 41.777344 12.289062 L 41.796875 12.265625 Z M 41.332031 11.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.183594 11.320312 L 41.054688 11.535156 L 41.757812 12.320312 L 41.777344 12.289062 Z M 41.183594 11.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.054688 11.535156 L 40.957031 11.777344 L 41.746094 12.351562 L 41.757812 12.320312 Z M 41.054688 11.535156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.957031 11.777344 L 40.890625 12.046875 L 41.734375 12.390625 L 41.746094 12.351562 Z M 40.957031 11.777344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.890625 12.046875 L 40.859375 12.328125 L 41.730469 12.433594 L 41.734375 12.390625 Z M 40.890625 12.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 512.869111 148.977371 L 521.922986 150.073525 L 517.781751 227.372684 L 508.727876 226.317128 Z M 512.869111 148.977371 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.332031 19.871094 L 41.300781 20.195312 L 40.445312 19.914062 L 40.460938 19.769531 Z M 41.332031 19.871094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.300781 20.195312 L 41.242188 20.507812 L 40.417969 20.054688 L 40.445312 19.914062 Z M 41.300781 20.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.242188 20.507812 L 41.152344 20.808594 L 40.378906 20.191406 L 40.417969 20.054688 Z M 41.242188 20.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.152344 20.808594 L 41.039062 21.085938 L 40.324219 20.316406 L 40.378906 20.191406 Z M 41.152344 20.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.039062 21.085938 L 40.898438 21.335938 L 40.261719 20.433594 L 40.324219 20.316406 Z M 41.039062 21.085938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.898438 21.335938 L 40.738281 21.558594 L 40.191406 20.535156 L 40.261719 20.433594 Z M 40.898438 21.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.738281 21.558594 L 40.5625 21.746094 L 40.109375 20.617188 L 40.191406 20.535156 Z M 40.738281 21.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.5625 21.746094 L 40.367188 21.894531 L 40.019531 20.6875 L 40.109375 20.617188 Z M 40.5625 21.746094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.367188 21.894531 L 40.164062 22.003906 L 39.929688 20.734375 L 40.019531 20.6875 Z M 40.367188 21.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.164062 22.003906 L 39.949219 22.070312 L 39.832031 20.765625 L 39.929688 20.734375 Z M 40.164062 22.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 39.949219 22.070312 L 39.730469 22.089844 L 39.730469 20.773438 L 39.832031 20.765625 Z M 39.949219 22.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 325.01135 236.75089 L 501.135613 236.75089 L 501.135613 250.432517 L 325.01135 250.432517 Z M 325.01135 236.75089 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.785156 22.089844 L 22.566406 22.070312 L 22.683594 20.765625 L 22.785156 20.773438 Z M 22.785156 22.089844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.566406 22.070312 L 22.355469 22.003906 L 22.589844 20.734375 L 22.683594 20.765625 Z M 22.566406 22.070312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.355469 22.003906 L 22.148438 21.894531 L 22.496094 20.6875 L 22.589844 20.734375 Z M 22.355469 22.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.148438 21.894531 L 21.953125 21.746094 L 22.40625 20.617188 L 22.496094 20.6875 Z M 22.148438 21.894531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.953125 21.746094 L 21.777344 21.558594 L 22.324219 20.535156 L 22.40625 20.617188 Z M 21.953125 21.746094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.777344 21.558594 L 21.617188 21.335938 L 22.253906 20.433594 L 22.324219 20.535156 Z M 21.777344 21.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.617188 21.335938 L 21.476562 21.085938 L 22.191406 20.316406 L 22.253906 20.433594 Z M 21.617188 21.335938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.476562 21.085938 L 21.363281 20.808594 L 22.136719 20.191406 L 22.191406 20.316406 Z M 21.476562 21.085938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.363281 20.808594 L 21.277344 20.507812 L 22.097656 20.054688 L 22.136719 20.191406 Z M 21.363281 20.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.277344 20.507812 L 21.214844 20.195312 L 22.070312 19.914062 L 22.097656 20.054688 Z M 21.277344 20.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.214844 20.195312 L 21.183594 19.871094 L 22.054688 19.769531 L 22.070312 19.914062 Z M 21.214844 20.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 317.419087 226.317128 L 308.365212 227.372684 L 304.223978 150.073525 L 313.318453 148.977371 Z M 317.419087 226.317128 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.660156 12.328125 L 21.625 12.046875 L 20.78125 12.390625 L 20.785156 12.433594 Z M 21.660156 12.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.625 12.046875 L 21.558594 11.777344 L 20.769531 12.351562 L 20.78125 12.390625 Z M 21.625 12.046875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.558594 11.777344 L 21.460938 11.535156 L 20.757812 12.320312 L 20.769531 12.351562 Z M 21.558594 11.777344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.460938 11.535156 L 21.332031 11.320312 L 20.738281 12.289062 L 20.757812 12.320312 Z M 21.460938 11.535156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.332031 11.320312 L 21.183594 11.148438 L 20.71875 12.265625 L 20.738281 12.289062 Z M 21.332031 11.320312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.183594 11.148438 L 21.011719 11.019531 L 20.695312 12.246094 L 20.71875 12.265625 Z M 21.183594 11.148438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.011719 11.019531 L 20.828125 10.941406 L 20.667969 12.234375 L 20.695312 12.246094 Z M 21.011719 11.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 20.828125 10.941406 L 20.640625 10.914062 L 20.640625 12.230469 L 20.667969 12.234375 Z M 20.828125 10.941406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 302.721765 134.280788 L 302.721765 147.962414 L 303.777374 147.962414 L 294.642298 134.280788 Z M 302.721765 134.280788 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 294.642298 134.280788 L 303.777374 147.962414 L 303.777374 248.159012 L 294.642298 261.80004 Z M 294.642298 134.280788 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 294.642298 261.80004 L 303.777374 248.159012 L 526.957428 248.159012 L 526.957428 261.80004 Z M 294.642298 261.80004 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 522.41019 346.082105 L 531.504665 346.082105 L 531.504665 466.780844 L 522.41019 453.139816 Z M 522.41019 346.082105 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 522.41019 453.139816 L 531.504665 466.780844 L 523.425198 466.780844 L 523.425198 453.139816 Z M 522.41019 453.139816 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.875 42.90625 L 41.6875 42.878906 L 41.847656 41.589844 L 41.875 41.59375 Z M 41.875 42.90625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.6875 42.878906 L 41.503906 42.800781 L 41.824219 41.578125 L 41.847656 41.589844 Z M 41.6875 42.878906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.503906 42.800781 L 41.332031 42.671875 L 41.796875 41.558594 L 41.824219 41.578125 Z M 41.503906 42.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.332031 42.671875 L 41.183594 42.5 L 41.777344 41.53125 L 41.796875 41.558594 Z M 41.332031 42.671875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.183594 42.5 L 41.054688 42.289062 L 41.757812 41.503906 L 41.777344 41.53125 Z M 41.183594 42.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.054688 42.289062 L 40.957031 42.042969 L 41.746094 41.46875 L 41.757812 41.503906 Z M 41.054688 42.289062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.957031 42.042969 L 40.890625 41.777344 L 41.734375 41.429688 L 41.746094 41.46875 Z M 40.957031 42.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.890625 41.777344 L 40.859375 41.496094 L 41.730469 41.390625 L 41.734375 41.429688 Z M 40.890625 41.777344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 521.922986 451.028704 L 512.869111 452.124858 L 508.727876 374.785102 L 517.781751 373.688948 Z M 521.922986 451.028704 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.332031 33.949219 L 41.300781 33.628906 L 40.445312 33.90625 L 40.460938 34.054688 Z M 41.332031 33.949219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.300781 33.628906 L 41.242188 33.3125 L 40.417969 33.765625 L 40.445312 33.90625 Z M 41.300781 33.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.242188 33.3125 L 41.152344 33.015625 L 40.378906 33.628906 L 40.417969 33.765625 Z M 41.242188 33.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.152344 33.015625 L 41.039062 32.738281 L 40.324219 33.503906 L 40.378906 33.628906 Z M 41.152344 33.015625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 41.039062 32.738281 L 40.898438 32.484375 L 40.261719 33.390625 L 40.324219 33.503906 Z M 41.039062 32.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.898438 32.484375 L 40.738281 32.265625 L 40.191406 33.289062 L 40.261719 33.390625 Z M 40.898438 32.484375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.738281 32.265625 L 40.5625 32.078125 L 40.109375 33.203125 L 40.191406 33.289062 Z M 40.738281 32.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.5625 32.078125 L 40.367188 31.929688 L 40.019531 33.136719 L 40.109375 33.203125 Z M 40.5625 32.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.367188 31.929688 L 40.164062 31.820312 L 39.929688 33.085938 L 40.019531 33.136719 Z M 40.367188 31.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 40.164062 31.820312 L 39.949219 31.753906 L 39.832031 33.054688 L 39.929688 33.085938 Z M 40.164062 31.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 39.949219 31.753906 L 39.730469 31.730469 L 39.730469 33.046875 L 39.832031 33.054688 Z M 39.949219 31.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 325.01135 350.629115 L 501.135613 350.629115 L 501.135613 364.310741 L 325.01135 364.310741 Z M 325.01135 350.629115 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.785156 31.730469 L 22.566406 31.753906 L 22.683594 33.054688 L 22.785156 33.046875 Z M 22.785156 31.730469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.566406 31.753906 L 22.355469 31.820312 L 22.589844 33.085938 L 22.683594 33.054688 Z M 22.566406 31.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.355469 31.820312 L 22.148438 31.929688 L 22.496094 33.136719 L 22.589844 33.085938 Z M 22.355469 31.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 22.148438 31.929688 L 21.953125 32.078125 L 22.40625 33.203125 L 22.496094 33.136719 Z M 22.148438 31.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.953125 32.078125 L 21.777344 32.265625 L 22.324219 33.289062 L 22.40625 33.203125 Z M 21.953125 32.078125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.777344 32.265625 L 21.617188 32.484375 L 22.253906 33.390625 L 22.324219 33.289062 Z M 21.777344 32.265625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.617188 32.484375 L 21.476562 32.738281 L 22.191406 33.503906 L 22.253906 33.390625 Z M 21.617188 32.484375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.476562 32.738281 L 21.363281 33.015625 L 22.136719 33.628906 L 22.191406 33.503906 Z M 21.476562 32.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.363281 33.015625 L 21.277344 33.3125 L 22.097656 33.765625 L 22.136719 33.628906 Z M 21.363281 33.015625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.277344 33.3125 L 21.214844 33.628906 L 22.070312 33.90625 L 22.097656 33.765625 Z M 21.277344 33.3125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.214844 33.628906 L 21.183594 33.949219 L 22.054688 34.054688 L 22.070312 33.90625 Z M 21.214844 33.628906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 308.365212 373.688948 L 317.419087 374.785102 L 313.318453 452.124858 L 304.223978 451.028704 Z M 308.365212 373.688948 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.660156 41.496094 L 21.625 41.777344 L 20.78125 41.429688 L 20.785156 41.390625 Z M 21.660156 41.496094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.625 41.777344 L 21.558594 42.042969 L 20.769531 41.46875 L 20.78125 41.429688 Z M 21.625 41.777344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.558594 42.042969 L 21.460938 42.289062 L 20.757812 41.503906 L 20.769531 41.46875 Z M 21.558594 42.042969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.460938 42.289062 L 21.332031 42.5 L 20.738281 41.53125 L 20.757812 41.503906 Z M 21.460938 42.289062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.332031 42.5 L 21.183594 42.671875 L 20.71875 41.558594 L 20.738281 41.53125 Z M 21.332031 42.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.183594 42.671875 L 21.011719 42.800781 L 20.695312 41.578125 L 20.71875 41.558594 Z M 21.183594 42.671875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 21.011719 42.800781 L 20.828125 42.878906 L 20.667969 41.589844 L 20.695312 41.578125 Z M 21.011719 42.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 20.828125 42.878906 L 20.640625 42.90625 L 20.640625 41.59375 L 20.667969 41.589844 Z M 20.828125 42.878906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 302.721765 453.139816 L 302.721765 466.780844 L 294.642298 466.780844 L 303.777374 453.139816 Z M 302.721765 453.139816 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 303.777374 453.139816 L 294.642298 466.780844 L 294.642298 339.261592 L 303.777374 352.902619 Z M 303.777374 453.139816 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 303.777374 352.902619 L 294.642298 339.261592 L 526.957428 339.261592 L 526.957428 352.902619 Z M 303.777374 352.902619 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 178.281732 280.840641 L 182.057563 267.199614 L 186.320598 267.199614 L 190.09643 280.840641 Z M 178.281732 280.840641 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 190.09643 280.840641 L 186.320598 267.199614 L 188.147614 264.438929 L 191.923445 278.120556 Z M 190.09643 280.840641 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 191.923445 278.120556 L 188.147614 264.438929 L 197.485691 264.438929 L 188.391216 278.120556 Z M 191.923445 278.120556 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 188.391216 278.120556 L 197.485691 264.438929 L 197.485691 333.902616 L 188.391216 320.22099 Z M 188.391216 278.120556 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 188.391216 320.22099 L 197.485691 333.902616 L 187.335607 333.902616 L 183.559776 320.22099 Z M 188.391216 320.22099 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 183.559776 320.22099 L 187.335607 333.902616 L 185.508592 336.622702 L 181.73276 322.981674 Z M 183.559776 320.22099 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 181.73276 322.981674 L 185.508592 336.622702 L 177.469725 336.622702 L 181.245556 322.981674 Z M 181.73276 322.981674 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 181.245556 322.981674 L 177.469725 336.622702 L 175.68331 333.902616 L 179.459141 320.22099 Z M 181.245556 322.981674 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 179.459141 320.22099 L 175.68331 333.902616 L 171.379674 333.902616 L 167.603843 320.22099 Z M 179.459141 320.22099 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 167.603843 320.22099 L 171.379674 333.902616 L 169.552659 336.622702 L 165.817428 322.981674 Z M 167.603843 320.22099 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 165.817428 322.981674 L 169.552659 336.622702 L 161.554393 336.622702 L 165.330224 322.981674 Z M 165.817428 322.981674 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 165.330224 322.981674 L 161.554393 336.622702 L 159.727378 333.902616 L 163.503209 320.22099 Z M 165.330224 322.981674 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 163.503209 320.22099 L 159.727378 333.902616 L 155.464342 333.902616 L 151.688511 320.22099 Z M 163.503209 320.22099 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 151.688511 320.22099 L 155.464342 333.902616 L 153.637327 336.622702 L 149.861496 322.981674 Z M 151.688511 320.22099 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 149.861496 322.981674 L 153.637327 336.622702 L 145.59846 336.622702 L 149.374292 322.981674 Z M 149.861496 322.981674 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 149.374292 322.981674 L 145.59846 336.622702 L 143.771445 333.902616 L 147.547276 320.22099 Z M 149.374292 322.981674 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 147.547276 320.22099 L 143.771445 333.902616 L 134.433368 333.902616 L 143.568443 320.22099 Z M 147.547276 320.22099 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 143.568443 320.22099 L 134.433368 333.902616 L 134.433368 267.199614 L 143.568443 280.840641 Z M 143.568443 320.22099 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 143.568443 280.840641 L 134.433368 267.199614 L 138.493401 267.199614 L 142.269233 280.840641 Z M 143.568443 280.840641 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 142.269233 280.840641 L 138.493401 267.199614 L 140.320416 264.438929 L 144.096248 278.120556 Z M 142.269233 280.840641 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 144.096248 278.120556 L 140.320416 264.438929 L 148.359283 264.438929 L 144.583452 278.120556 Z M 144.096248 278.120556 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 144.583452 278.120556 L 148.359283 264.438929 L 150.186298 267.199614 L 146.369867 280.840641 Z M 144.583452 278.120556 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 146.369867 280.840641 L 150.186298 267.199614 L 154.449334 267.199614 L 158.225165 280.840641 Z M 146.369867 280.840641 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 158.225165 280.840641 L 154.449334 267.199614 L 156.276349 264.438929 L 160.01158 278.120556 Z M 158.225165 280.840641 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 160.01158 278.120556 L 156.276349 264.438929 L 164.274615 264.438929 L 160.498784 278.120556 Z M 160.01158 278.120556 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 160.498784 278.120556 L 164.274615 264.438929 L 166.101631 267.199614 L 162.325799 280.840641 Z M 160.498784 278.120556 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 162.325799 280.840641 L 166.101631 267.199614 L 170.364666 267.199614 L 174.140497 280.840641 Z M 162.325799 280.840641 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 174.140497 280.840641 L 170.364666 267.199614 L 172.191681 264.438929 L 175.967512 278.120556 Z M 174.140497 280.840641 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 175.967512 278.120556 L 172.191681 264.438929 L 180.230548 264.438929 L 176.454717 278.120556 Z M 175.967512 278.120556 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 176.454717 278.120556 L 180.230548 264.438929 L 182.057563 267.199614 L 178.281732 280.840641 Z M 176.454717 278.120556 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.273246 157.056433 L 273.408322 170.738059 L 273.408322 430.323573 L 264.273246 444.005199 Z M 264.273246 157.056433 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.273246 444.005199 L 273.408322 430.323573 L 294.642298 430.323573 L 303.777374 444.005199 Z M 264.273246 444.005199 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 303.777374 444.005199 L 294.642298 430.323573 L 294.642298 170.738059 L 303.777374 157.056433 Z M 303.777374 444.005199 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 303.777374 157.056433 L 294.642298 170.738059 L 273.408322 170.738059 L 264.273246 157.056433 Z M 303.777374 157.056433 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 273.408322 274.344914 L 264.273246 260.703886 L 303.777374 260.703886 L 294.642298 274.344914 Z M 273.408322 274.344914 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 294.642298 274.344914 L 303.777374 260.703886 L 303.777374 340.398344 L 294.642298 326.716718 Z M 294.642298 274.344914 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 294.642298 326.716718 L 303.777374 340.398344 L 264.273246 340.398344 L 273.408322 326.716718 Z M 294.642298 326.716718 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 273.408322 326.716718 L 264.273246 340.398344 L 264.273246 260.703886 L 273.408322 274.344914 Z M 273.408322 326.716718 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 197.120288 254.776535 L 193.344457 241.135507 L 268.455081 241.135507 L 264.679249 254.776535 Z M 197.120288 254.776535 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.679249 254.776535 L 268.455081 241.135507 L 273.408322 248.524397 L 264.273246 254.208158 Z M 264.679249 254.776535 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.273246 254.208158 L 273.408322 248.524397 L 273.408322 352.537235 L 264.273246 346.894071 Z M 264.273246 254.208158 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.273246 346.894071 L 273.408322 352.537235 L 268.455081 359.966723 L 264.679249 346.285097 Z M 264.273246 346.894071 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.679249 346.285097 L 268.455081 359.966723 L 193.344457 359.966723 L 197.120288 346.285097 Z M 264.679249 346.285097 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 197.120288 346.285097 L 193.344457 359.966723 L 188.391216 352.537235 L 197.485691 346.894071 Z M 197.120288 346.285097 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 197.485691 346.894071 L 188.391216 352.537235 L 188.391216 248.524397 L 197.485691 254.208158 Z M 197.485691 346.894071 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 197.485691 254.208158 L 188.391216 248.524397 L 193.344457 241.135507 L 197.120288 254.776535 Z M 197.485691 254.208158 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 195.212072 267.402605 L 266.587465 267.402605 L 266.587465 281.084231 L 195.212072 281.084231 Z M 195.212072 267.402605 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 195.212072 320.017999 L 266.587465 320.017999 L 266.587465 333.659026 L 195.212072 333.659026 Z M 195.212072 320.017999 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.914062 21.53125 L 9.808594 21.863281 L 10.617188 22.367188 L 10.679688 22.171875 Z M 9.914062 21.53125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.808594 21.863281 L 9.726562 22.207031 L 10.566406 22.574219 L 10.617188 22.367188 Z M 9.808594 21.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.726562 22.207031 L 9.671875 22.566406 L 10.535156 22.789062 L 10.566406 22.574219 Z M 9.726562 22.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.671875 22.566406 L 9.644531 22.929688 L 10.519531 23.007812 L 10.535156 22.789062 Z M 9.671875 22.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.644531 22.929688 L 9.644531 23.300781 L 10.519531 23.226562 L 10.519531 23.007812 Z M 9.644531 22.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.644531 23.300781 L 9.671875 23.664062 L 10.535156 23.445312 L 10.519531 23.226562 Z M 9.644531 23.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.671875 23.664062 L 9.726562 24.023438 L 10.566406 23.65625 L 10.535156 23.445312 Z M 9.671875 23.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.726562 24.023438 L 9.808594 24.371094 L 10.617188 23.863281 L 10.566406 23.65625 Z M 9.726562 24.023438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.808594 24.371094 L 9.914062 24.699219 L 10.679688 24.0625 L 10.617188 23.863281 Z M 9.808594 24.371094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.875 24.214844 L 9.78125 24.804688 L 10.640625 25.066406 L 10.722656 24.550781 Z M 9.875 24.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.78125 24.804688 L 9.710938 25.402344 L 10.578125 25.589844 L 10.640625 25.066406 Z M 9.78125 24.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.710938 25.402344 L 9.667969 26.003906 L 10.539062 26.117188 L 10.578125 25.589844 Z M 9.710938 25.402344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.667969 26.003906 L 9.640625 26.609375 L 10.519531 26.644531 L 10.539062 26.117188 Z M 9.667969 26.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.640625 26.609375 L 9.640625 27.214844 L 10.519531 27.175781 L 10.519531 26.644531 Z M 9.640625 26.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.640625 27.214844 L 9.667969 27.820312 L 10.539062 27.707031 L 10.519531 27.175781 Z M 9.640625 27.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.667969 27.820312 L 9.710938 28.421875 L 10.578125 28.234375 L 10.539062 27.707031 Z M 9.667969 27.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.710938 28.421875 L 9.78125 29.019531 L 10.640625 28.757812 L 10.578125 28.234375 Z M 9.710938 28.421875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.78125 29.019531 L 9.875 29.609375 L 10.722656 29.273438 L 10.640625 28.757812 Z M 9.78125 29.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.914062 29.121094 L 9.808594 29.453125 L 10.617188 29.957031 L 10.679688 29.761719 Z M 9.914062 29.121094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.808594 29.453125 L 9.726562 29.796875 L 10.566406 30.164062 L 10.617188 29.957031 Z M 9.808594 29.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.726562 29.796875 L 9.671875 30.15625 L 10.535156 30.378906 L 10.566406 30.164062 Z M 9.726562 29.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.671875 30.15625 L 9.644531 30.523438 L 10.519531 30.597656 L 10.535156 30.378906 Z M 9.671875 30.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.644531 30.523438 L 9.644531 30.890625 L 10.519531 30.816406 L 10.519531 30.597656 Z M 9.644531 30.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.644531 30.890625 L 9.671875 31.253906 L 10.535156 31.035156 L 10.519531 30.816406 Z M 9.644531 30.890625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.671875 31.253906 L 9.726562 31.613281 L 10.566406 31.246094 L 10.535156 31.035156 Z M 9.671875 31.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.726562 31.613281 L 9.808594 31.960938 L 10.617188 31.453125 L 10.566406 31.246094 Z M 9.726562 31.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 9.808594 31.960938 L 9.914062 32.292969 L 10.679688 31.652344 L 10.617188 31.453125 Z M 9.808594 31.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.546875 24.699219 L 17.652344 24.371094 L 16.84375 23.863281 L 16.78125 24.0625 Z M 17.546875 24.699219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.652344 24.371094 L 17.734375 24.023438 L 16.890625 23.65625 L 16.84375 23.863281 Z M 17.652344 24.371094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.734375 24.023438 L 17.789062 23.664062 L 16.925781 23.445312 L 16.890625 23.65625 Z M 17.734375 24.023438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.789062 23.664062 L 17.816406 23.300781 L 16.941406 23.226562 L 16.925781 23.445312 Z M 17.789062 23.664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.816406 23.300781 L 17.816406 22.929688 L 16.941406 23.007812 L 16.941406 23.226562 Z M 17.816406 23.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.816406 22.929688 L 17.789062 22.566406 L 16.925781 22.789062 L 16.941406 23.007812 Z M 17.816406 22.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.789062 22.566406 L 17.734375 22.207031 L 16.890625 22.574219 L 16.925781 22.789062 Z M 17.789062 22.566406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.734375 22.207031 L 17.652344 21.863281 L 16.84375 22.367188 L 16.890625 22.574219 Z M 17.734375 22.207031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.652344 21.863281 L 17.546875 21.53125 L 16.78125 22.171875 L 16.84375 22.367188 Z M 17.652344 21.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.585938 29.609375 L 17.679688 29.019531 L 16.820312 28.757812 L 16.738281 29.273438 Z M 17.585938 29.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.679688 29.019531 L 17.746094 28.421875 L 16.878906 28.234375 L 16.820312 28.757812 Z M 17.679688 29.019531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.746094 28.421875 L 17.792969 27.820312 L 16.921875 27.707031 L 16.878906 28.234375 Z M 17.746094 28.421875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.792969 27.820312 L 17.816406 27.214844 L 16.941406 27.175781 L 16.921875 27.707031 Z M 17.792969 27.820312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.816406 27.214844 L 17.816406 26.609375 L 16.941406 26.644531 L 16.941406 27.175781 Z M 17.816406 27.214844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.816406 26.609375 L 17.792969 26.003906 L 16.921875 26.117188 L 16.941406 26.644531 Z M 17.816406 26.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.792969 26.003906 L 17.746094 25.402344 L 16.878906 25.589844 L 16.921875 26.117188 Z M 17.792969 26.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.746094 25.402344 L 17.679688 24.804688 L 16.820312 25.066406 L 16.878906 25.589844 Z M 17.746094 25.402344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.679688 24.804688 L 17.585938 24.214844 L 16.738281 24.550781 L 16.820312 25.066406 Z M 17.679688 24.804688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.546875 32.292969 L 17.652344 31.960938 L 16.84375 31.453125 L 16.78125 31.652344 Z M 17.546875 32.292969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.652344 31.960938 L 17.734375 31.613281 L 16.890625 31.246094 L 16.84375 31.453125 Z M 17.652344 31.960938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.734375 31.613281 L 17.789062 31.253906 L 16.925781 31.035156 L 16.890625 31.246094 Z M 17.734375 31.613281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.789062 31.253906 L 17.816406 30.890625 L 16.941406 30.816406 L 16.925781 31.035156 Z M 17.789062 31.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.816406 30.890625 L 17.816406 30.523438 L 16.941406 30.597656 L 16.941406 30.816406 Z M 17.816406 30.890625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.816406 30.523438 L 17.789062 30.15625 L 16.925781 30.378906 L 16.941406 30.597656 Z M 17.816406 30.523438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.789062 30.15625 L 17.734375 29.796875 L 16.890625 30.164062 L 16.925781 30.378906 Z M 17.789062 30.15625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.734375 29.796875 L 17.652344 29.453125 L 16.84375 29.957031 L 16.890625 30.164062 Z M 17.734375 29.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.652344 29.453125 L 17.546875 29.121094 L 16.78125 29.761719 L 16.84375 29.957031 Z M 17.652344 29.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 271.297104 333.902616 L 275.072936 320.22099 L 276.899951 322.981674 L 273.124119 336.622702 Z M 271.297104 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 273.124119 336.622702 L 276.899951 322.981674 L 277.387155 322.981674 L 281.162986 336.622702 Z M 273.124119 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 281.162986 336.622702 L 277.387155 322.981674 L 279.21417 320.22099 L 282.990001 333.902616 Z M 281.162986 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 282.990001 333.902616 L 279.21417 320.22099 L 291.028868 320.22099 L 287.253037 333.902616 Z M 282.990001 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 287.253037 333.902616 L 291.028868 320.22099 L 292.855883 322.981674 L 289.080052 336.622702 Z M 287.253037 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 289.080052 336.622702 L 292.855883 322.981674 L 293.343087 322.981674 L 297.118919 336.622702 Z M 289.080052 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 297.118919 336.622702 L 293.343087 322.981674 L 295.170103 320.22099 L 298.905334 333.902616 Z M 297.118919 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 298.905334 333.902616 L 295.170103 320.22099 L 306.984801 320.22099 L 303.208969 333.902616 Z M 298.905334 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 303.208969 333.902616 L 306.984801 320.22099 L 308.771215 322.981674 L 305.035984 336.622702 Z M 303.208969 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 305.035984 336.622702 L 308.771215 322.981674 L 309.25842 322.981674 L 313.034251 336.622702 Z M 305.035984 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 313.034251 336.622702 L 309.25842 322.981674 L 311.085435 320.22099 L 314.861266 333.902616 Z M 313.034251 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 314.861266 333.902616 L 311.085435 320.22099 L 322.900133 320.22099 L 319.124301 333.902616 Z M 314.861266 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 319.124301 333.902616 L 322.900133 320.22099 L 324.727148 322.981674 L 320.951317 336.622702 Z M 319.124301 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 320.951317 336.622702 L 324.727148 322.981674 L 325.214352 322.981674 L 328.990183 336.622702 Z M 320.951317 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 328.990183 336.622702 L 325.214352 322.981674 L 327.041367 320.22099 L 330.817199 333.902616 Z M 328.990183 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 330.817199 333.902616 L 327.041367 320.22099 L 338.856065 320.22099 L 335.080234 333.902616 Z M 330.817199 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 335.080234 333.902616 L 338.856065 320.22099 L 340.683081 322.981674 L 336.907249 336.622702 Z M 335.080234 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 336.907249 336.622702 L 340.683081 322.981674 L 341.170285 322.981674 L 344.905516 336.622702 Z M 336.907249 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 344.905516 336.622702 L 341.170285 322.981674 L 342.956699 320.22099 L 346.732531 333.902616 Z M 344.905516 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 346.732531 333.902616 L 342.956699 320.22099 L 354.771398 320.22099 L 351.036167 333.902616 Z M 346.732531 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 351.036167 333.902616 L 354.771398 320.22099 L 356.598413 322.981674 L 352.822581 336.622702 Z M 351.036167 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 352.822581 336.622702 L 356.598413 322.981674 L 357.085617 322.981674 L 360.861448 336.622702 Z M 352.822581 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 360.861448 336.622702 L 357.085617 322.981674 L 358.912632 320.22099 L 362.688463 333.902616 Z M 360.861448 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 362.688463 333.902616 L 358.912632 320.22099 L 370.72733 320.22099 L 366.951499 333.902616 Z M 362.688463 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 366.951499 333.902616 L 370.72733 320.22099 L 372.554345 322.981674 L 368.778514 336.622702 Z M 366.951499 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 368.778514 336.622702 L 372.554345 322.981674 L 373.041549 322.981674 L 376.817381 336.622702 Z M 368.778514 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 376.817381 336.622702 L 373.041549 322.981674 L 374.868564 320.22099 L 378.644396 333.902616 Z M 376.817381 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 378.644396 333.902616 L 374.868564 320.22099 L 386.683263 320.22099 L 382.907431 333.902616 Z M 378.644396 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 382.907431 333.902616 L 386.683263 320.22099 L 388.510278 322.981674 L 384.734446 336.622702 Z M 382.907431 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 384.734446 336.622702 L 388.510278 322.981674 L 388.956881 322.981674 L 392.732713 336.622702 Z M 384.734446 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 392.732713 336.622702 L 388.956881 322.981674 L 390.783897 320.22099 L 394.559728 333.902616 Z M 392.732713 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 394.559728 333.902616 L 390.783897 320.22099 L 402.598595 320.22099 L 398.822763 333.902616 Z M 394.559728 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 398.822763 333.902616 L 402.598595 320.22099 L 404.42561 322.981674 L 400.649779 336.622702 Z M 398.822763 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 400.649779 336.622702 L 404.42561 322.981674 L 404.912814 322.981674 L 408.688645 336.622702 Z M 400.649779 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 408.688645 336.622702 L 404.912814 322.981674 L 406.739829 320.22099 L 410.515661 333.902616 Z M 408.688645 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 410.515661 333.902616 L 406.739829 320.22099 L 418.554527 320.22099 L 414.778696 333.902616 Z M 410.515661 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 414.778696 333.902616 L 418.554527 320.22099 L 420.381543 322.981674 L 416.605711 336.622702 Z M 414.778696 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 416.605711 336.622702 L 420.381543 322.981674 L 420.868747 322.981674 L 424.644578 336.622702 Z M 416.605711 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 424.644578 336.622702 L 420.868747 322.981674 L 422.695762 320.22099 L 426.430993 333.902616 Z M 424.644578 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 426.430993 333.902616 L 422.695762 320.22099 L 434.51046 320.22099 L 430.734628 333.902616 Z M 426.430993 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 430.734628 333.902616 L 434.51046 320.22099 L 436.337475 322.981674 L 432.561644 336.622702 Z M 430.734628 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 432.561644 336.622702 L 436.337475 322.981674 L 436.784079 322.981674 L 440.55991 336.622702 Z M 432.561644 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 440.55991 336.622702 L 436.784079 322.981674 L 438.611094 320.22099 L 442.386925 333.902616 Z M 440.55991 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 442.386925 333.902616 L 438.611094 320.22099 L 450.425792 320.22099 L 446.649961 333.902616 Z M 442.386925 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 446.649961 333.902616 L 450.425792 320.22099 L 452.252807 322.981674 L 448.476976 336.622702 Z M 446.649961 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 448.476976 336.622702 L 452.252807 322.981674 L 452.740011 322.981674 L 456.515843 336.622702 Z M 448.476976 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 456.515843 336.622702 L 452.740011 322.981674 L 454.567026 320.22099 L 458.342858 333.902616 Z M 456.515843 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 458.342858 333.902616 L 454.567026 320.22099 L 466.381725 320.22099 L 462.605893 333.902616 Z M 458.342858 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 462.605893 333.902616 L 466.381725 320.22099 L 468.20874 322.981674 L 464.432908 336.622702 Z M 462.605893 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 464.432908 336.622702 L 468.20874 322.981674 L 468.695944 322.981674 L 472.431175 336.622702 Z M 464.432908 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 472.431175 336.622702 L 468.695944 322.981674 L 470.482359 320.22099 L 474.25819 333.902616 Z M 472.431175 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 474.25819 333.902616 L 470.482359 320.22099 L 482.337657 320.22099 L 478.561826 333.902616 Z M 474.25819 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 478.561826 333.902616 L 482.337657 320.22099 L 484.124072 322.981674 L 480.388841 336.622702 Z M 478.561826 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 480.388841 336.622702 L 484.124072 322.981674 L 484.611276 322.981674 L 488.387107 336.622702 Z M 480.388841 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 488.387107 336.622702 L 484.611276 322.981674 L 486.438291 320.22099 L 490.214123 333.902616 Z M 488.387107 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 490.214123 333.902616 L 486.438291 320.22099 L 498.252989 320.22099 L 494.477158 333.902616 Z M 490.214123 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 494.477158 333.902616 L 498.252989 320.22099 L 500.080004 322.981674 L 496.304173 336.622702 Z M 494.477158 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 496.304173 336.622702 L 500.080004 322.981674 L 500.567208 322.981674 L 504.34304 336.622702 Z M 496.304173 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 504.34304 336.622702 L 500.567208 322.981674 L 502.394224 320.22099 L 506.170055 333.902616 Z M 504.34304 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 506.170055 333.902616 L 502.394224 320.22099 L 514.208922 320.22099 L 510.43309 333.902616 Z M 506.170055 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 510.43309 333.902616 L 514.208922 320.22099 L 516.035937 322.981674 L 512.260106 336.622702 Z M 510.43309 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 512.260106 336.622702 L 516.035937 322.981674 L 516.482541 322.981674 L 520.258372 336.622702 Z M 512.260106 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 520.258372 336.622702 L 516.482541 322.981674 L 518.309556 320.22099 L 522.085387 333.902616 Z M 520.258372 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 522.085387 333.902616 L 518.309556 320.22099 L 530.124254 320.22099 L 526.389023 333.902616 Z M 522.085387 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 526.389023 333.902616 L 530.124254 320.22099 L 531.951269 322.981674 L 528.175438 336.622702 Z M 526.389023 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 528.175438 336.622702 L 531.951269 322.981674 L 532.438473 322.981674 L 536.214305 336.622702 Z M 528.175438 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 536.214305 336.622702 L 532.438473 322.981674 L 534.265488 320.22099 L 538.04132 333.902616 Z M 536.214305 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 538.04132 333.902616 L 534.265488 320.22099 L 546.080187 320.22099 L 542.304355 333.902616 Z M 538.04132 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 542.304355 333.902616 L 546.080187 320.22099 L 547.907202 322.981674 L 544.13137 336.622702 Z M 542.304355 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 544.13137 336.622702 L 547.907202 322.981674 L 548.394406 322.981674 L 552.170237 336.622702 Z M 544.13137 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 552.170237 336.622702 L 548.394406 322.981674 L 550.221421 320.22099 L 553.997252 333.902616 Z M 552.170237 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 553.997252 333.902616 L 550.221421 320.22099 L 562.036119 320.22099 L 558.260288 333.902616 Z M 553.997252 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 558.260288 333.902616 L 562.036119 320.22099 L 563.863134 322.981674 L 560.087303 336.622702 Z M 558.260288 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 560.087303 336.622702 L 563.863134 322.981674 L 564.309738 322.981674 L 568.085569 336.622702 Z M 560.087303 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 568.085569 336.622702 L 564.309738 322.981674 L 566.136753 320.22099 L 569.912584 333.902616 Z M 568.085569 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 569.912584 333.902616 L 566.136753 320.22099 L 577.951451 320.22099 L 574.17562 333.902616 Z M 569.912584 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 574.17562 333.902616 L 577.951451 320.22099 L 579.778466 322.981674 L 576.002635 336.622702 Z M 574.17562 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 576.002635 336.622702 L 579.778466 322.981674 L 580.26567 322.981674 L 584.041502 336.622702 Z M 576.002635 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 584.041502 336.622702 L 580.26567 322.981674 L 582.092686 320.22099 L 585.868517 333.902616 Z M 584.041502 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 585.868517 333.902616 L 582.092686 320.22099 L 593.907384 320.22099 L 590.131552 333.902616 Z M 585.868517 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 590.131552 333.902616 L 593.907384 320.22099 L 595.734399 322.981674 L 591.958568 336.622702 Z M 590.131552 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 591.958568 336.622702 L 595.734399 322.981674 L 596.221603 322.981674 L 599.997434 336.622702 Z M 591.958568 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 599.997434 336.622702 L 596.221603 322.981674 L 598.048618 320.22099 L 601.783849 333.902616 Z M 599.997434 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 601.783849 333.902616 L 598.048618 320.22099 L 609.863316 320.22099 L 606.087485 333.902616 Z M 601.783849 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 606.087485 333.902616 L 609.863316 320.22099 L 611.649731 322.981674 L 607.9145 336.622702 Z M 606.087485 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 607.9145 336.622702 L 611.649731 322.981674 L 612.136935 322.981674 L 615.912767 336.622702 Z M 607.9145 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 615.912767 336.622702 L 612.136935 322.981674 L 613.96395 320.22099 L 617.739782 333.902616 Z M 615.912767 336.622702 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 617.739782 333.902616 L 613.96395 320.22099 L 612.66474 320.22099 L 621.799815 333.902616 Z M 617.739782 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 621.799815 333.902616 L 612.66474 320.22099 L 612.66474 280.840641 L 621.799815 267.199614 Z M 621.799815 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 621.799815 267.199614 L 612.66474 280.840641 L 608.685907 280.840641 L 612.461738 267.199614 Z M 621.799815 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 612.461738 267.199614 L 608.685907 280.840641 L 606.858891 278.120556 L 610.634723 264.438929 Z M 612.461738 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 610.634723 264.438929 L 606.858891 278.120556 L 606.371687 278.120556 L 602.595856 264.438929 Z M 610.634723 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 602.595856 264.438929 L 606.371687 278.120556 L 604.544672 280.840641 L 600.809441 267.199614 Z M 602.595856 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 600.809441 267.199614 L 604.544672 280.840641 L 592.729974 280.840641 L 596.505805 267.199614 Z M 600.809441 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 596.505805 267.199614 L 592.729974 280.840641 L 590.902959 278.120556 L 594.67879 264.438929 Z M 596.505805 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 594.67879 264.438929 L 590.902959 278.120556 L 590.456355 278.120556 L 586.680524 264.438929 Z M 594.67879 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 586.680524 264.438929 L 590.456355 278.120556 L 588.62934 280.840641 L 584.853509 267.199614 Z M 586.680524 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 584.853509 267.199614 L 588.62934 280.840641 L 576.814642 280.840641 L 580.549873 267.199614 Z M 584.853509 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 580.549873 267.199614 L 576.814642 280.840641 L 574.987627 278.120556 L 578.763458 264.438929 Z M 580.549873 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 578.763458 264.438929 L 574.987627 278.120556 L 574.500423 278.120556 L 570.724591 264.438929 Z M 578.763458 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 570.724591 264.438929 L 574.500423 278.120556 L 572.673407 280.840641 L 568.897576 267.199614 Z M 570.724591 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 568.897576 267.199614 L 572.673407 280.840641 L 560.858709 280.840641 L 564.634541 267.199614 Z M 568.897576 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 564.634541 267.199614 L 560.858709 280.840641 L 559.031694 278.120556 L 562.807525 264.438929 Z M 564.634541 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 562.807525 264.438929 L 559.031694 278.120556 L 558.54449 278.120556 L 554.809259 264.438929 Z M 562.807525 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 554.809259 264.438929 L 558.54449 278.120556 L 556.758075 280.840641 L 552.982244 267.199614 Z M 554.809259 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 552.982244 267.199614 L 556.758075 280.840641 L 544.902777 280.840641 L 548.678608 267.199614 Z M 552.982244 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 548.678608 267.199614 L 544.902777 280.840641 L 543.116362 278.120556 L 546.851593 264.438929 Z M 548.678608 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 546.851593 264.438929 L 543.116362 278.120556 L 542.629158 278.120556 L 538.853326 264.438929 Z M 546.851593 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 538.853326 264.438929 L 542.629158 278.120556 L 540.802143 280.840641 L 537.026311 267.199614 Z M 538.853326 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 537.026311 267.199614 L 540.802143 280.840641 L 528.987445 280.840641 L 532.763276 267.199614 Z M 537.026311 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 532.763276 267.199614 L 528.987445 280.840641 L 527.160429 278.120556 L 530.936261 264.438929 Z M 532.763276 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 530.936261 264.438929 L 527.160429 278.120556 L 526.673225 278.120556 L 522.897394 264.438929 Z M 530.936261 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 522.897394 264.438929 L 526.673225 278.120556 L 524.84621 280.840641 L 521.070379 267.199614 Z M 522.897394 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 521.070379 267.199614 L 524.84621 280.840641 L 513.031512 280.840641 L 516.807343 267.199614 Z M 521.070379 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 516.807343 267.199614 L 513.031512 280.840641 L 511.204497 278.120556 L 514.980328 264.438929 Z M 516.807343 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 514.980328 264.438929 L 511.204497 278.120556 L 510.757893 278.120556 L 506.941461 264.438929 Z M 514.980328 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 506.941461 264.438929 L 510.757893 278.120556 L 508.930878 280.840641 L 505.155047 267.199614 Z M 506.941461 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 505.155047 267.199614 L 508.930878 280.840641 L 497.11618 280.840641 L 500.851411 267.199614 Z M 505.155047 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 500.851411 267.199614 L 497.11618 280.840641 L 495.289165 278.120556 L 499.064996 264.438929 Z M 500.851411 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 499.064996 264.438929 L 495.289165 278.120556 L 494.801961 278.120556 L 491.026129 264.438929 Z M 499.064996 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 491.026129 264.438929 L 494.801961 278.120556 L 492.974945 280.840641 L 489.199114 267.199614 Z M 491.026129 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 489.199114 267.199614 L 492.974945 280.840641 L 481.160247 280.840641 L 484.936079 267.199614 Z M 489.199114 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 484.936079 267.199614 L 481.160247 280.840641 L 479.333232 278.120556 L 483.109063 264.438929 Z M 484.936079 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 483.109063 264.438929 L 479.333232 278.120556 L 478.846028 278.120556 L 475.070197 264.438929 Z M 483.109063 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 475.070197 264.438929 L 478.846028 278.120556 L 477.019013 280.840641 L 473.243182 267.199614 Z M 475.070197 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 473.243182 267.199614 L 477.019013 280.840641 L 465.204315 280.840641 L 468.980146 267.199614 Z M 473.243182 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 468.980146 267.199614 L 465.204315 280.840641 L 463.3773 278.120556 L 467.153131 264.438929 Z M 468.980146 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 467.153131 264.438929 L 463.3773 278.120556 L 462.890096 278.120556 L 459.154865 264.438929 Z M 467.153131 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 459.154865 264.438929 L 462.890096 278.120556 L 461.103681 280.840641 L 457.327849 267.199614 Z M 459.154865 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 457.327849 267.199614 L 461.103681 280.840641 L 449.288983 280.840641 L 453.064814 267.199614 Z M 457.327849 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 453.064814 267.199614 L 449.288983 280.840641 L 447.461967 278.120556 L 451.237799 264.438929 Z M 453.064814 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 451.237799 264.438929 L 447.461967 278.120556 L 446.974763 278.120556 L 443.198932 264.438929 Z M 451.237799 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 443.198932 264.438929 L 446.974763 278.120556 L 445.147748 280.840641 L 441.371917 267.199614 Z M 443.198932 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 441.371917 267.199614 L 445.147748 280.840641 L 433.33305 280.840641 L 437.108881 267.199614 Z M 441.371917 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 437.108881 267.199614 L 433.33305 280.840641 L 431.506035 278.120556 L 435.281866 264.438929 Z M 437.108881 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 435.281866 264.438929 L 431.506035 278.120556 L 431.018831 278.120556 L 427.242999 264.438929 Z M 435.281866 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 427.242999 264.438929 L 431.018831 278.120556 L 429.191816 280.840641 L 425.456585 267.199614 Z M 427.242999 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 425.456585 267.199614 L 429.191816 280.840641 L 417.377118 280.840641 L 421.152949 267.199614 Z M 425.456585 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 421.152949 267.199614 L 417.377118 280.840641 L 415.550102 278.120556 L 419.325934 264.438929 Z M 421.152949 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 419.325934 264.438929 L 415.550102 278.120556 L 415.103499 278.120556 L 411.327667 264.438929 Z M 419.325934 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 411.327667 264.438929 L 415.103499 278.120556 L 413.276483 280.840641 L 409.500652 267.199614 Z M 411.327667 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 409.500652 267.199614 L 413.276483 280.840641 L 401.461785 280.840641 L 405.237617 267.199614 Z M 409.500652 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 405.237617 267.199614 L 401.461785 280.840641 L 399.63477 278.120556 L 403.410602 264.438929 Z M 405.237617 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 403.410602 264.438929 L 399.63477 278.120556 L 399.147566 278.120556 L 395.371735 264.438929 Z M 403.410602 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 395.371735 264.438929 L 399.147566 278.120556 L 397.320551 280.840641 L 393.54472 267.199614 Z M 395.371735 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 393.54472 267.199614 L 397.320551 280.840641 L 385.505853 280.840641 L 389.281684 267.199614 Z M 393.54472 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 389.281684 267.199614 L 385.505853 280.840641 L 383.678838 278.120556 L 387.454669 264.438929 Z M 389.281684 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 387.454669 264.438929 L 383.678838 278.120556 L 383.191634 278.120556 L 379.456403 264.438929 Z M 387.454669 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 379.456403 264.438929 L 383.191634 278.120556 L 381.405219 280.840641 L 377.629387 267.199614 Z M 379.456403 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 377.629387 267.199614 L 381.405219 280.840641 L 369.54992 280.840641 L 373.325752 267.199614 Z M 377.629387 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 373.325752 267.199614 L 369.54992 280.840641 L 367.763505 278.120556 L 371.539337 264.438929 Z M 373.325752 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 371.539337 264.438929 L 367.763505 278.120556 L 367.276301 278.120556 L 363.50047 264.438929 Z M 371.539337 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 363.50047 264.438929 L 367.276301 278.120556 L 365.449286 280.840641 L 361.673455 267.199614 Z M 363.50047 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 361.673455 267.199614 L 365.449286 280.840641 L 353.634588 280.840641 L 357.410419 267.199614 Z M 361.673455 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 357.410419 267.199614 L 353.634588 280.840641 L 351.807573 278.120556 L 355.583404 264.438929 Z M 357.410419 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 355.583404 264.438929 L 351.807573 278.120556 L 351.320369 278.120556 L 347.544538 264.438929 Z M 355.583404 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 347.544538 264.438929 L 351.320369 278.120556 L 349.493354 280.840641 L 345.717522 267.199614 Z M 347.544538 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 345.717522 267.199614 L 349.493354 280.840641 L 337.678656 280.840641 L 341.454487 267.199614 Z M 345.717522 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 341.454487 267.199614 L 337.678656 280.840641 L 335.85164 278.120556 L 339.627472 264.438929 Z M 341.454487 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 339.627472 264.438929 L 335.85164 278.120556 L 335.405037 278.120556 L 331.629205 264.438929 Z M 339.627472 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 331.629205 264.438929 L 335.405037 278.120556 L 333.578022 280.840641 L 329.80219 267.199614 Z M 331.629205 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 329.80219 267.199614 L 333.578022 280.840641 L 321.722723 280.840641 L 325.539155 267.199614 Z M 329.80219 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 325.539155 267.199614 L 321.722723 280.840641 L 319.936308 278.120556 L 323.71214 264.438929 Z M 325.539155 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 323.71214 264.438929 L 319.936308 278.120556 L 319.449104 278.120556 L 315.673273 264.438929 Z M 323.71214 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 315.673273 264.438929 L 319.449104 278.120556 L 317.622089 280.840641 L 313.846258 267.199614 Z M 315.673273 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 313.846258 267.199614 L 317.622089 280.840641 L 305.807391 280.840641 L 309.583222 267.199614 Z M 313.846258 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 309.583222 267.199614 L 305.807391 280.840641 L 303.980376 278.120556 L 307.756207 264.438929 Z M 309.583222 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 307.756207 264.438929 L 303.980376 278.120556 L 303.493172 278.120556 L 299.71734 264.438929 Z M 307.756207 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 299.71734 264.438929 L 303.493172 278.120556 L 301.666156 280.840641 L 297.890325 267.199614 Z M 299.71734 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 297.890325 267.199614 L 301.666156 280.840641 L 298.41813 280.840641 L 298.41813 267.199614 Z M 297.890325 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 298.41813 267.199614 L 298.41813 280.840641 L 289.851458 280.840641 L 293.62729 267.199614 Z M 298.41813 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 293.62729 267.199614 L 289.851458 280.840641 L 288.024443 278.120556 L 291.800275 264.438929 Z M 293.62729 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 291.800275 264.438929 L 288.024443 278.120556 L 287.577839 278.120556 L 283.802008 264.438929 Z M 291.800275 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 283.802008 264.438929 L 287.577839 278.120556 L 285.750824 280.840641 L 281.974993 267.199614 Z M 283.802008 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 281.974993 267.199614 L 285.750824 280.840641 L 273.936126 280.840641 L 277.671357 267.199614 Z M 281.974993 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 277.671357 267.199614 L 273.936126 280.840641 L 272.109111 278.120556 L 275.884942 264.438929 Z M 277.671357 267.199614 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 275.884942 264.438929 L 272.109111 278.120556 L 271.621907 278.120556 L 267.846076 264.438929 Z M 275.884942 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 267.846076 264.438929 L 271.621907 278.120556 L 273.408322 275.441068 L 264.273246 269.797905 Z M 267.846076 264.438929 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.273246 269.797905 L 273.408322 275.441068 L 273.408322 320.22099 L 264.273246 333.902616 Z M 264.273246 269.797905 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0962123, 0, 0, 0.0962171, -8.484919, -2.006044)",
    fillOpacity: 1,
    fill: "#ffffff",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 264.273246 333.902616 L 273.408322 320.22099 L 275.072936 320.22099 L 271.297104 333.902616 Z M 264.273246 333.902616 ",
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalingLight);
export default __webpack_public_path__ + "static/media/Waling_light.6fa5418538a987a2a4a4af117a0f8b3c.svg";
export { ForwardRef as ReactComponent };